import React from 'react';
import { useSelector } from 'store';
import { filterUnreadChatUsersByView } from 'utils/chat';

const useUnreadCount = (
  viewId: 'my-chats' | 'not-my-chats' | 'unassigned-chats' | 'bots-chats' | 'chats' | undefined,
): number => {
  const unreadChatUsers = useSelector((state) => state.unreadChatUsers);
  const userId = useSelector((state) => state.user?.Udid);

  const count = React.useMemo(() => {
    const filteredUsers = filterUnreadChatUsersByView(unreadChatUsers, userId, viewId);
    return filteredUsers.length;
  }, [unreadChatUsers, userId, viewId]);

  return count;
};

export default useUnreadCount;
